import script from "./EmptyContent.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyContent.vue?vue&type=script&setup=true&lang=js"

import "./EmptyContent.vue?vue&type=style&index=0&id=6c3b7cd1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c3b7cd1"]])

export default __exports__